import React, { useEffect, useState } from "react";
import Chart from "react-apexcharts";
import { getAnalyticsChartData } from "../../../config/service";
import ChartLoader from "./Loading";

const DevicesChart = ({
  utm,
  toDate,
  fromDate,
  isLoader,
  setIsLoader,
  activeTab,
}) => {
  const [data, setData] = useState(null);

  useEffect(() => {
    handleFetchData();
  }, [utm, toDate, activeTab]);

  const handleFetchData = async () => {
    try {
      setIsLoader(true);
      const response = await getAnalyticsChartData({
        type: "devices",
        utm: utm?.value || "",
        dateFrom: fromDate ? fromDate.toISOString().split("T")[0] : "",
        dateTo: toDate ? toDate.toISOString().split("T")[0] : "",
      });
      setData(response.data);
    } catch (error) {
      console.error("Error fetching devices data:", error);
    } finally {
      setIsLoader(false);
    }
  };

  if (isLoader || !data) return <ChartLoader isLoader={isLoader} />;
    if (!isLoader && (!data || data.totalSessions === 0))
      return (
        <div className="d-flex justify-content-center align-items-center py-5">
          <h4>No data available</h4>
        </div>
      );

    const options = {
      labels: data.devices.map((d) => d.type),
    };

    const series = data.devices.map((d) => d.count);

    return (
      <>
        <Chart options={options} series={series} type="pie" height={400} />{" "}
        <div className="conversion-count">
          <h4>
            Total Sessions (<span>{data.totalSessions}</span>)
          </h4>
        </div>
      </>
    );
};

export default DevicesChart;